import { useFormContext, useWatch } from 'react-hook-form';

import { useUploadFiles } from 'src/shared/components/file-upload/useFileUpload';

import Title from 'src/refactor_components/common/Title';
import { useToast } from '#providers/ToastProvider';

const PdfUpload = ({
  titleText,
  registerName
}: {
  titleText: string;
  registerName: string;
}) => {
  const methods = useFormContext();
  const { showToast } = useToast();
  const { uploadFiles: uploadFilesToS3 } = useUploadFiles();

  const files = useWatch({
    control: methods.control,
    name: registerName
  });

  const uploadFiles = async (filesArray: File[]) => {
    if (filesArray.length > 0) {
      uploadFilesToS3({
        selectedFiles: filesArray,
        path: 'non-image-files',
        onError: () => {
          showToast({
            type: 'fail',
            message: '파일 업로드에 실패하였습니다. 파일 형식은 Pdf여야 합니다.'
          });
        },
        onSuccess: value => {
          methods.setValue(registerName, [
            {
              id: value.id,
              uploadedLink: URL.createObjectURL(filesArray[0]),
              fileName: value.file.name
            }
          ]);
        }
      });
    }
  };

  return (
    <>
      <div className="flex flex-col gap-8">
        <Title text={titleText} />
        <input
          type="file"
          className="hidden"
          id="upload"
          onChange={e => {
            const selectedFiles = e.target.files;

            if (!selectedFiles) return;
            const filesArray = Array.from(selectedFiles);

            uploadFiles(filesArray);
          }}
        />
        <label
          htmlFor="upload"
          className="py-17 px-16 w-full rounded-8 bg-[#1F1E25] text-[#5C576B]"
        >
          {files && files.length ? (
            <a href={files[0].uploadedLink} download={files[0].fileName}>
              {files[0].fileName}
            </a>
          ) : (
            <p>파일 업로드</p>
          )}
        </label>
      </div>
      <div className="flex flex-col gap-20">
        <p className="text-[14px] text-[#746D87]">
          해당 이력을 증명할 수 있는 자료를 제출해주시면 '검증된 자격사항'을
          의미하는 인증 배지가 부여됩 니다.
        </p>

        <p className="text-[14px] text-[#746D87]">
          허위 사실 기재에 대한 책임은 본인에게 있습니다.
        </p>
      </div>
    </>
  );
};

export default PdfUpload;
